module.exports = __webpack_public_path__ + "static/media/comment-alt-edit.a8b80414.svg";